import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import DebriefingService from '../../../services/DebriefingService';
import { ISetMarkerByDebriefing } from '../../../types/Markers';

interface TabsProps {
  id: string | number;
  title: 'Dados Simulação' | 'Checklist' | 'Video Simulação' | 'Considerações' | 'Feedback' | 'Dados IA';
}

const TABS: TabsProps[] = [
  { id: '1', title: 'Dados Simulação' },
  { id: '2', title: 'Checklist' },
  { id: '5', title: 'Dados IA' },
  { id: '3', title: 'Considerações' },
  { id: '4', title: 'Feedback' },
];

const TABS_STUDENT: TabsProps[] = [
  { id: '1', title: 'Dados Simulação' },
  { id: '2', title: 'Checklist' },
  { id: '4', title: 'Feedback' },
];

export const useDebriefings = (isAppraiser: boolean = false) => {

  const { evaluatedId, eventId } = useParams<{ evaluatedId: string; eventId: string }>();

  const [dataTabsMenu, setDataTabsMenu] = useState<TabsProps[]>([]);

  const profileId = secureLocalStorage.getItem('role') as number | null;

  const getDebriefingEventByEvaluated = useCallback(async () => {
    if (!evaluatedId || !eventId || !profileId) return;

    try {
      const response = await DebriefingService.getDebriefingEventByEvaluated({ evaluatedId, eventId });
      const status = response.data[0]?.status;

      if (profileId === 5 && !isAppraiser) {
        setDataTabsMenu(TABS_STUDENT);
      } else {
        setDataTabsMenu(TABS);
      }
    } catch (error) {
      console.error('Error fetching debriefing event by evaluated:', error);
    }
  }, [evaluatedId, eventId, profileId, isAppraiser]);

  useEffect(() => {
    getDebriefingEventByEvaluated();
  }, [getDebriefingEventByEvaluated]);

  const setMarkerByDebriefing = (data: ISetMarkerByDebriefing) => {
    // Implement functionality as needed
  };

  return {
    dataTabsMenu,
    getDebriefingEventByEvaluated,
    setMarkerByDebriefing,
  };
};
